import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type HarvenRole = "user" | "assistant";

export interface HarvenMessage {
  id: string;
  role: HarvenRole;
  content: string;
  createdAt: string;
  usedSources?: Array<Record<string, any>>;
  downloadUrl?: string;
  downloadFilename?: string;
}

export interface HarvenChatState {
  messagesByUser: Record<string, HarvenMessage[]>;
}

const initialState: HarvenChatState = {
  messagesByUser: {},
};

const harvenChatSlice = createSlice({
  name: "harvenChat",
  initialState,
  reducers: {
    setConversation: (
      state,
      action: PayloadAction<{ userId: string; messages: HarvenMessage[] }>
    ) => {
      state.messagesByUser[action.payload.userId] = action.payload.messages;
    },
    addMessage: (
      state,
      action: PayloadAction<{ userId: string; message: HarvenMessage }>
    ) => {
      const list = state.messagesByUser[action.payload.userId] || [];
      list.push(action.payload.message);
      state.messagesByUser[action.payload.userId] = list;
    },
    clearConversation: (state, action: PayloadAction<{ userId: string }>) => {
      state.messagesByUser[action.payload.userId] = [];
    },
  },
});

export const { setConversation, addMessage, clearConversation } =
  harvenChatSlice.actions;

export default harvenChatSlice.reducer;
